
module.exports = function(app) {

  return new Promise(resolve => {

    app.modAInfo = 'hello';
    resolve({
      endpoints: [
        {
          path: '/hello',
        },
      ],
    });
  });
};
